import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import type { JpdProjectMenuProps } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jpd-project-menu/src/ui/JpdProjectMenu.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { SkeletonNavMenuItems } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';

const Skeleton = () => <SkeletonNavMenuItems count={1} />;

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jpd-project-menu" */ './ui'
		).then(({ JpdProjectMenu }) => JpdProjectMenu),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncJpdProjectMenu = memo(
	({ projectData, menuItemButtonRef }: JpdProjectMenuProps) => (
		<SidebarBoundary
			id="nav4.sidebar.jpd-project-menu"
			packageName="jiraNavigationAppsSidebarNav4JPDProjectMenu"
			ufoName="nav4.sidebar.jpd-project-menu"
		>
			<Placeholder name="nav4.sidebar.jpd-project-menu" fallback={<Skeleton />}>
				<LazySidebarContent projectData={projectData} menuItemButtonRef={menuItemButtonRef} />
			</Placeholder>
		</SidebarBoundary>
	),
);
